import React, { Component, Fragment } from "react";
import axios from "axios";
import { axiosConfig, ValidateEmail, normalize } from "../../../config/utility";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  addNewSubClient,
  getAddSubClientEmailPreview,
  getFccFiler,
  isFccIntegrationEnabled,
  listSubClients,
} from "./../../../config/api_calls";
import { getCustomSettings, getClientRegistrationSettings } from "./../../../config/reseller_api_calls";
import $ from "jquery";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { THEME_TEXT_COLOR, THEME_COLOR } from "./../../../config/config";
import TextField from "../../../components/InputFields/TextField";
import SelectField from "../../../components/InputFields/SelectField";
import MutextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import StepWizard from "react-step-wizard";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/build/index.css";
import Select from "react-select";
import countryList from "react-select-country-list";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { PhoneNumberUtil } from "google-libphonenumber";
import FccFilerAutocomplete from "../../../components/InputFields/FccFilerAutocomplete";
import PasswordStrengthBar from "react-password-strength-bar";

import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const auth = new HelperClass();

class Addclient extends Component {
  constructor() {
    super();
    this.state = {
      serviceData: [],
      select_service: "",
      errorMessage: "",
      serviceId: "",
      title: "",
      name: "",
      logo: "",
      client_email: "",
      client_phone: "",
      client_company: "",
      client_password: "",
      c_password: "",
      client_address: "",
      client_address2: "",
      client_city: "",
      client_state: "",
      client_zip: "",
      client_country: "United States",
      description: "",
      successMessage: "",
      tableLoader: true,
      domain: "",
      step: 1,
      dnsList: [],
      a_ip: "",
      is_verified: 0,
      AgentsList: [],
      select_agent: "",
      notifyCheckBox: false,
      account_status: "",
      passwordShown: false,
      confirmPasswordShown: false,
      errorSelectAgent: "",
      errorName: "",
      errorClientTitle: "",
      errorClientStatus: "",
      errorClientCompany: "",
      errorClientEmail: "",
      errorClientPhone: "",
      errorClientAddress: "",
      errorClientCity: "",
      errorClientState: "",
      errorClientZip: "",
      errorClientCountry: "",
      errorClientPassword: "",
      errorCPassword: "",
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",
      passwordRequired: false,
      main_client_name: "",
      client_accountno: "",
      address_autocomplete: true,
      address_validation: true,
      is_fcc_enabled: "No",
      has_fcc_filer_id: false,
      filer_id: "",
      errorFilerId: "",
      fccLoading: false,
      fccSuccess: false,
      fcc_data: null,
      lastVerifiedFilerId: "",
      fcc_contact_email: "",
      fcc_ocn: "",
      fcc_frn: "",
      fcc_number: "",
      fcc_coresid: "",
      fcc_filing_url: "",
      registrationFieldSettings: {}, // Settings for field requirements (required/optional)
      isParentCompanyReadOnly: false,
    };
    this.countryOptions = countryList()
      .getData()
      .filter(
        (country) => country.label !== "United States Minor Outlying Islands",
      )
      .sort((a, b) => {
        if (a.label === "United States") return -1;
        if (b.label === "United States") return 1;
        return a.label.localeCompare(b.label);
      });
  }

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      const normalized = phone.startsWith("+") ? phone : `+${phone}`;
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(normalized),
      );
    } catch (error) {
      return false;
    }
  };

  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };

  serviceSigning = async (value, tableMeta) => {
    // console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  async componentDidMount() {
    const { client_accountno } = this.props.props.match.params;
    // console.log("client_accountno: ", client_accountno);

    this.setState({
      client_accountno: client_accountno,
    });
    const clientsResponce = await listSubClients(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );

    // console.log("Client Data: ", clientsResponce.data);
    if (
      clientsResponce.data.status === 403 ||
      clientsResponce.data.errors === "authentication missing" ||
      clientsResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      clientsResponce.data.status === 404 ||
      clientsResponce.data.note === "missing"
    ) {
      // window.location.replace("/error");
      // console.log("settings missing");
      this.setState({
        tableLoader: false,
      });
    } else if (
      clientsResponce.data.status === 200 &&
      clientsResponce.data.message === "success"
    ) {
      const mainClientInfo = clientsResponce.data.mainClientInfo || {};

      this.setState({
        tableData: clientsResponce.data.data,
        all_client_data: clientsResponce.data.all_data,
        main_client_name: mainClientInfo.name,
        tableLoader: false,
      }, () => {
        this.populateParentClientDetails(mainClientInfo);
      });
    } else {
      this.setState({
        tableLoader: false,
      });
      // window.location.replace("/error");
    }
    this.getCustomSettings();
    await this.loadRegistrationSettings();
  }

  getSanitizedParentFieldValue = (value) => {
    if (value === null || value === undefined) {
      return "";
    }

    return typeof value === "string" ? value.trim() : value;
  };

  getInitialFormFieldValue = (currentValue, sourceValue, fallback = "") => {
    if (
      currentValue !== null &&
      currentValue !== undefined &&
      currentValue !== ""
    ) {
      return currentValue;
    }

    if (sourceValue !== null && sourceValue !== undefined && sourceValue !== "") {
      return sourceValue;
    }

    return fallback;
  };

  populateParentClientDetails = (mainClientInfo = {}) => {
    const parentCompanyName = this.getSanitizedParentFieldValue(
      mainClientInfo.comp_name,
    );
    const parentAddress = this.getSanitizedParentFieldValue(
      mainClientInfo.address,
    );
    const parentCity = this.getSanitizedParentFieldValue(mainClientInfo.city);
    const parentState = this.getSanitizedParentFieldValue(mainClientInfo.state);
    const parentZip = this.getSanitizedParentFieldValue(mainClientInfo.zip);
    const parentCountry = this.getSanitizedParentFieldValue(
      mainClientInfo.country,
    );

    this.setState((prevState) => ({
      client_company: this.getInitialFormFieldValue(
        prevState.client_company,
        parentCompanyName,
      ),
      client_address: this.getInitialFormFieldValue(
        prevState.client_address,
        parentAddress,
      ),
      client_city: this.getInitialFormFieldValue(prevState.client_city, parentCity),
      client_state: this.getInitialFormFieldValue(
        prevState.client_state,
        parentState,
      ),
      client_zip: this.getInitialFormFieldValue(prevState.client_zip, parentZip),
      client_country: this.getInitialFormFieldValue(
        prevState.client_country,
        parentCountry,
        null,
      ),
      isParentCompanyReadOnly: parentCompanyName !== "",
    }));
  };

  normalizeFccPhoneTemp = (phone) => {
    if (!phone) return "";

    // Remove non-digit characters
    const digits = phone.replace(/\D/g, "");

    // Only modify if exactly 10 digits
    if (digits.length === 10) {
      return `1${digits}`;
    }

    // Otherwise return original value
    return phone;
  };

  parseAddressWithGoogle = async (address) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          address,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK" && data.results.length > 0) {
        const result = data.results[0];
        const addressComponents = result.address_components;

        let city = "";
        let state = "";
        let zip = "";
        let country = "";

        addressComponents.forEach((component) => {
          const types = component.types;
          if (types.includes("locality")) {
            city = component.long_name;
          } else if (types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (types.includes("postal_code")) {
            zip = component.long_name;
          } else if (types.includes("country")) {
            country = component.long_name;
          }
        });

        this.setState({
          client_address: result.formatted_address || address,
          client_city: city || this.state.client_city,
          client_state: state || this.state.client_state,
          client_zip: zip || this.state.client_zip,
          client_country: country || this.state.client_country,
          errorClientAddress: "",
          errorClientCity: "",
          errorClientState: "",
          errorClientZip: "",
          errorClientCountry: "",
        });
      }
    } catch (error) {
      console.error("Error parsing address with Google:", error);
      this.setState({
        client_address: address,
      });
    }
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    // console.log("dczdczxcxzcxzc");
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      // console.log("handleAddressSelect: ", data);
      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        //console.log("addressComponents: ", data.results);
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          client_city: city && city !== "" ? city : "",
          client_state: state && state !== "" ? state : "",
          client_zip: zipCode && zipCode !== "" ? zipCode : "",
          client_country: country && country !== "" ? country : "",
          client_address:
            streetAddress && streetAddress !== "" ? streetAddress : "",
          client_address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  handleChangeCountry = (event) => {
    const country = event ? event.label : "";
    this.setState({
      client_country: country,
    });
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  handleChange = (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (name === "name") {
      value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
    } else if (name === "title") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    } else if (name === "client_company") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    }
    this.setState({
      [name]: value,
    });
  };

  handleChangeStep = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  handleChangeFile = async (event) => {
    this.setState({
      rate_deck_file: event.target.files[0],
    });
    //await this.sendFileData(event.target.files[0]);
  };

  modalHide = () => {
    window.$("#modalAlert").modal("hide");
    // this.props.agreementSigned();
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  nextStep = () => {
    const { step } = this.state;

    this.setState({
      step: step + 1,
    });
    // console.log("STEP: ", this.state.step);
  };

  // Go to prev step
  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1,
    });
  };
  firstStep = () => {
    this.setState({
      step: 1,
    });
  };

  formClientUpdate = async () => {
    let {
      title,
      name,
      client_email,
      client_password,
      c_password,
      client_phone,
      client_company,
      client_address,
      client_address2,
      client_city,
      client_state,
      client_zip,
      client_country,
      select_agent,
      account_status,
    } = this.state;
    this.setState({
      successMessage: "",
      errorMessage: "",
      errorSelectAgent: "",
      errorName: "",
      errorClientTitle: "",
      errorClientStatus: "",
      errorClientCompany: "",
      errorClientEmail: "",
      errorClientPhone: "",
      errorClientAddress: "",
      errorClientCity: "",
      errorClientState: "",
      errorClientZip: "",
      errorClientCountry: "",
      errorClientPassword: "",
      errorCPassword: "",
      errorPass: "",
    });
    let is_validated = true;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    if (this.state.is_fcc_enabled === "Yes" && this.state.has_fcc_filer_id && this.state.filer_id === "") {
      this.setState({
        errorFilerId: "error",
        errorMessage: "499 Filer ID is required.",
      });
      is_validated = false;
    } else if (
      this.state.is_fcc_enabled === "Yes" &&
      this.state.has_fcc_filer_id &&
      this.state.filer_id !== "" &&
      this.state.filer_id !== this.state.lastVerifiedFilerId
    ) {
      this.setState({
        errorFilerId: "error",
        errorMessage: "Please verify the 499 Filer ID before submitting.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('name') && this.state.name === "") {
      this.setState({
        errorSelectAgent: "",
        errorName: "error",
        errorMessage: "Client Name is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('title') && this.state.title === "") {
      this.setState({
        errorSelectAgent: "",
        errorName: "",
        errorClientTitle: "error",
        errorMessage: "Client Title is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('account_status') && this.state.account_status === "") {
      this.setState({
        errorName: "",
        errorClientStatus: "error",
        errorMessage: "Account Status is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_company') && this.state.client_company === "") {
      this.setState({
        errorAccountStatus: "",
        errorClientCompany: "error",
        errorMessage: "Company name is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_email') && this.state.client_email === "") {
      this.setState({
        errorClientCompany: "",
        errorClientEmail: "error",
        errorMessage: "Email address is required.",
      });
      is_validated = false;
    } else if (this.state.client_email !== "" && ValidateEmail(this.state.client_email) === false) {
      this.setState({
        errorClientCompany: "",
        errorClientEmail: "error",
        errorMessage: "Invalid email format.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_phone') && this.state.client_phone === "") {
      this.setState({
        errorClientEmail: "",
        errorClientPhone: "error",
        errorMessage: "Phone is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_phone') && this.state.client_phone !== "" && !this.isPhoneValid(client_phone)) {
      this.setState({
        errorClientEmail: "",
        errorClientPhone: "error",
        errorMessage: "Invalid phone number.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_address') && this.state.client_address === "") {
      this.setState({
        errorClientPhone: "",
        errorClientAddress: "error",
        errorMessage: "Address is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_city') && this.state.client_city === "") {
      this.setState({
        errorClientAddress: "",
        errorClientCity: "error",
        errorMessage: "City is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_state') && this.state.client_state === "") {
      this.setState({
        errorClientCity: "",
        errorClientState: "error",
        errorMessage: "State is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_zip') && this.state.client_zip === "") {
      this.setState({
        errorClientState: "",
        errorClientZip: "error",
        errorMessage: "Zip/postal code is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_country') && (!this.state.client_country || this.state.client_country === "")) {
      this.setState({
        errorClientZip: "",
        errorClientCountry: "error",
        errorMessage: "Country is required.",
      });
      is_validated = false;
    } else if (
      this.state.passwordRequired &&
      this.isFieldRequired('client_password') &&
      this.state.client_password === ""
    ) {
      this.setState({
        errorClientCountry: "",
        errorClientPassword: "error",
        errorMessage: "Password is required.",
      });
      is_validated = false;
    } else if (
      this.state.passwordRequired &&
      this.state.client_password !== ""
    ) {
      if (
        this.state.passwordRequired &&
        this.state.client_password.length < 8
      ) {
        this.setState({
          errorClientCountry: "",
          errorClientPassword: "error",
          errorMessage: "Use 8 characters or more for your password.",
        });
        is_validated = false;
      } else if (
        this.state.passwordRequired &&
        !passwordRegex.test(client_password)
      ) {
        this.setState({
          errorClientCountry: "",
          errorClientPassword: "error",
          errorMessage:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (this.state.passwordRequired && this.state.c_password === "") {
        this.setState({
          errorClientPassword: "",
          errorCPassword: "error",
          errorMessage: "Confirm password is required.",
        });
        is_validated = false;
      } else if (
        this.state.passwordRequired &&
        this.state.c_password.length < 8
      ) {
        this.setState({
          errorClientPassword: "",
          errorCPassword: "error",
          errorMessage: "Use 8 characters or more for your confirm password.",
        });
        is_validated = false;
      } else if (
        this.state.client_password.trim() != this.state.c_password.trim()
      ) {
        this.setState({
          errorClientPassword: "",
          errorCPassword: "error",
          errorMessage: "Password and confirm password does not match.",
        });
        is_validated = false;
      }
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (is_validated) {
      let fcc_payload = null;
      if (this.state.is_fcc_enabled === "Yes" && this.state.has_fcc_filer_id && this.state.filer_id) {
        fcc_payload = {
          filer_id: this.state.filer_id,
          contact_email: this.state.fcc_contact_email,
          ocn: this.state.fcc_ocn,
          frn: this.state.fcc_frn,
          number: this.state.fcc_number,
          coresid: this.state.fcc_coresid,
        };
      }

      let apiResponce = await addNewSubClient(
        auth.getAccount(),
        auth.getToken(),
        title,
        name,
        client_email,
        client_password,
        client_phone,
        client_company,
        client_address,
        client_address2,
        client_city,
        client_state,
        client_zip,
        client_country,
        this.state.notifyCheckBox.toString(),
        account_status,
        this.state.passwordRequired.toString(),
        this.state.client_accountno,
        fcc_payload,
      );
      // console.log("Add Client Response: ", apiResponce.data);
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        const formattedErrorMessage =
          Array.isArray(apiResponce.data.errors) &&
          apiResponce.data.errors.length > 0
            ? apiResponce.data.errors.join("<br />")
            : "Address validation failed";

        this.setState({
          errorMessage: formattedErrorMessage,
          tableLoader: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "success"
      ) {
        this.setState({
          successMessage: "Sub User added successfully.",
          tableLoader: false,
        });
        setTimeout(() => {
          window.history.back();
        }, 3000);
      } else if (
        apiResponce.data.status === 405 &&
        apiResponce.data.message === "email_exists"
      ) {
        this.setState({
          errorMessage:
            "Email already exists. Please try different email address.",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "Missing required fields"
      ) {
        const fieldErrorMap = {
          name: "errorName",
          email: "errorClientEmail",
          client_phone: "errorClientPhone",
          client_company: "errorClientCompany",
          title: "errorClientTitle",
          client_address: "errorClientAddress",
          client_city: "errorClientCity",
          client_state: "errorClientState",
          client_zip: "errorClientZip",
          client_country: "errorClientCountry",
        };
        const errorUpdates = { disabled: false, tableLoader: false };
        const missingLabels = [];
        const errorsArray = Array.isArray(apiResponce.data.errors)
          ? apiResponce.data.errors
          : [];
        console.log("Missing required fields response:", apiResponce.data);
        if (errorsArray.length > 0) {
          errorsArray.forEach(({ field }) => {
            if (fieldErrorMap[field]) {
              errorUpdates[fieldErrorMap[field]] = "error";
            }
            missingLabels.push(field.replace(/_/g, " "));
          });
          errorUpdates.errorMessage = `Required fields are missing: ${missingLabels.join(", ")}.`;
        } else {
          errorUpdates.errorMessage = "Some required fields are missing. Please fill in all required fields and try again.";
        }
        this.setState(errorUpdates);
        return false;
      } else {
        this.setState({
          errorMessage: "Something went wrong,try again later.",
          disabled: false,
          tableLoader: false,
        });
        //auth.logout();
      }
    }
  };

  onFileChange = (event) => {
    // Update the state
    this.setState({ logo: event.target.files[0] });
  };

  preViewDefault = async () => {
    const getEmailResponse = await getAddSubClientEmailPreview(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("getEmailResponse: ", getEmailResponse.data);
    if (
      getEmailResponse.data.status === 403 ||
      getEmailResponse.data.errors === "authentication missing" ||
      getEmailResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (getEmailResponse.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      getEmailResponse.data.status === 200 &&
      getEmailResponse.data.message === "success"
    ) {
      let emailTemplate = getEmailResponse.data.data[0][3];
      let logoUrl = getEmailResponse.data.data[0]["reseller_logo"];

      if (emailTemplate && emailTemplate !== "") {
        // Replace company logo
        emailTemplate = emailTemplate.replace(/{{comp_logo}}/g, logoUrl);

        // Replace placeholders with user input values
        emailTemplate = emailTemplate.replace(
          /{{client_name}}/g,
          this.state.name || "{{client_name}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{comp_name}}/g,
          auth.getCompName() || "{{comp_name}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{client_company}}/g,
          this.state.client_company || "{{client_company}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{client_email}}/g,
          this.state.client_email || "{{client_email}}",
        );

        // Clean up any empty paragraphs
        emailTemplate = emailTemplate.replace(/<p>&nbsp;<\/p>/g, "");
      }

      this.setState({
        email_id: getEmailResponse.data.data[0][0],
        email_title: getEmailResponse.data.data[0][1],
        email_subject: getEmailResponse.data.data[0][2],
        email_template: emailTemplate,
        tableLoader: false,
        isEditorReady: true,
      });
      window.$("#modalPreviewDefaultModal").modal("show");
    } else {
      //window.location.replace("/error");
    }
  };

  closePreviewModal = () => {
    // Close the preview modal
    window.$("#modalPreviewDefaultModal").modal("hide");
  };

  loadRegistrationSettings = async () => {
    try {
      const response = await getClientRegistrationSettings(
        auth.getAccount(),
        auth.getToken(),
      );

      if (
        response.data.status === 200 &&
        response.data.message === "success" &&
        response.data.fields
      ) {
        this.setState({
          registrationFieldSettings: response.data.fields,
        });
      } else {
        // Default all configurable fields to 'required' if no settings found
        this.setState({
          registrationFieldSettings: {
            name: "required",
            title: "required",
            client_company: "required",
            client_phone: "required",
            client_address: "required",
            client_address2: "required",
            client_city: "required",
            client_state: "required",
            client_zip: "required",
            client_country: "required",
          },
        });
      }
    } catch (error) {
      console.error("Error loading registration settings:", error);
      // Default to required for configurable fields on error
      this.setState({
        registrationFieldSettings: {
          name: "required",
          title: "required",
          client_company: "required",
          client_phone: "required",
          client_address: "required",
          client_address2: "required",
          client_city: "required",
          client_state: "required",
          client_zip: "required",
          client_country: "required",
        },
      });
    }
  };

  isFieldRequired = (fieldName) => {
    const { registrationFieldSettings } = this.state;
    
    // Always required fields (locked - not configurable)
    const alwaysRequired = [
      'account_status',
      'client_email'
    ];
    
    // If field is in the always required list, return true
    if (alwaysRequired.includes(fieldName)) {
      return true;
    }
    
    // For configurable fields, check settings
    // If settings are not loaded or field not in settings, default to required
    if (!registrationFieldSettings || Object.keys(registrationFieldSettings).length === 0) {
      return true;
    }
    
    // Return true if field is marked as "required", false if "optional"
    return registrationFieldSettings[fieldName] === "required";
  };

  getCustomSettings = async () => {
    try {
      const getCustomSetting_res = await getCustomSettings(
        auth.getAccount(),
        auth.getToken(),
      );
      //console.log("getCustomSetting_res: ", getCustomSetting_res.data);
      if (
        getCustomSetting_res.data.status === 200 &&
        getCustomSetting_res.data.data &&
        getCustomSetting_res.data.data.length > 0
      ) {
        this.setState({
          address_autocomplete:
            getCustomSetting_res.data.data[0].address_autocomplete || "Yes",
          address_validation:
            getCustomSetting_res.data.data[0].address_validation || "Yes",
        });
      }

      // Check FCC integration status separately
      const fccStatusRes = await isFccIntegrationEnabled(
        auth.getAccount(),
        auth.getToken(),
      );
      if (
        fccStatusRes.data &&
        fccStatusRes.data.status === 200 &&
        fccStatusRes.data.is_fcc_enabled
      ) {
        this.setState({
          is_fcc_enabled: fccStatusRes.data.is_fcc_enabled,
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  render() {
    const { useGooglePlaces, toggleButtonText } = this.state;
    const errorStyle = this.state.errorClientAddress
      ? {
          input: (provided) => ({
            ...provided,
            borderColor: "red",
          }),
          control: (provided) => ({
            ...provided,
            borderColor: "red",
          }),
        }
      : {};
    return (
      <div className="nk-content " id="">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}

          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <HomeIcon fontSize="inherit" className="" />
                    Home
                  </Link>
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/clients")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    Clients
                  </Link>
                  <Typography color="textPrimary" className="">
                    Add New Sub User
                  </Typography>
                </Breadcrumbs>
                {/*<h3 className="nk-block-title page-title">
                  <PageTitle name="Add New Services" />
                </h3>*/}
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-md-12">
              <div className="card card-bordered">
                <div className="card-inner">
                  <div className="card-head">
                    <h6 className="card-title">
                      Register {auth.getCompName()} sub user account.
                    </h6>
                  </div>
                  {this.state.errorMessage !== "" ? (
                    <div className="example-alert">
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: this.state.errorMessage,
                            }}
                          ></p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.successMessage !== "" ? (
                    <div className="example-alert">
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.successMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <br />
                  <form
                    method="post"
                    encType="multipart/form-data"
                    autoComplete="off" role="presentation"
                  >
                    <div className="row g-4">
                      {this.state.is_fcc_enabled === "Yes" && (
                        <>
                          <div
                            className="custom-control custom-control-lg custom-checkbox col-lg-12"
                            style={{
                              padding: 0,
                              marginLeft: "3rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <div className="form-group">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="has_fcc_filer_id"
                                checked={this.state.has_fcc_filer_id}
                                onChange={(e) =>
                                  this.setState({
                                    has_fcc_filer_id: e.target.checked,
                                    filer_id: "",
                                    errorFilerId: "",
                                    fccSuccess: false,
                                  })
                                }
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="has_fcc_filer_id"
                              >
                                I have{" "}
                                <a
                                  href="https://apps.fcc.gov/cgb/form499/499a.cfm"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#6576ff",
                                    textDecoration: "underline",
                                  }}
                                >
                                  FCC 499 Filer ID
                                </a>
                              </label>
                            </div>
                          </div>
                          {this.state.has_fcc_filer_id && (
                            <div className="form-group col-md-12">
                              <FccFilerAutocomplete
                                variant="material"
                                value={this.state.filer_id}
                                error={this.state.errorFilerId === "error"}
                                disabled={false}
                                fccLoading={this.state.fccLoading}
                                fccSuccess={this.state.fccSuccess}
                                errorFilerId={this.state.errorFilerId}
                                onInputChange={(value) => {
                                  this.setState({
                                    filer_id: value,
                                    errorFilerId: "",
                                    fccSuccess: false,
                                    lastVerifiedFilerId:
                                      value === this.state.lastVerifiedFilerId
                                        ? this.state.lastVerifiedFilerId
                                        : "",
                                  });
                                }}
                                onSelect={(filerId) => {
                                  this.setState({
                                    filer_id: filerId,
                                    errorFilerId: "",
                                    fccSuccess: false,
                                  });
                                }}
                                onFccDataLoading={(loading) => {
                                  this.setState({ fccLoading: loading });
                                }}
                                onFccDataLoaded={(fccResponse, filerId) => {
                                  if (
                                    fccResponse.data.status === 200 &&
                                    fccResponse.data.frn_details?.data
                                  ) {
                                    const fccData = fccResponse.data.frn_details.data;
                                    const robocallData = fccData.robocall_data || {};
                                    this.setState({
                                      fccSuccess: true,
                                      fccLoading: false,
                                      fcc_data: fccData,
                                      lastVerifiedFilerId: filerId,
                                      client_company: robocallData.business_name || "",
                                      name: robocallData.robocall_mitigation_contact_name || "",
                                      title: robocallData.contact_title || "",
                                      client_phone: this.normalizeFccPhoneTemp(robocallData.contact_telephone_number),
                                      client_country: robocallData.contact_country || null,
                                      fcc_contact_email: robocallData.contact_email || "",
                                      fcc_ocn: robocallData.ocn || "",
                                      fcc_frn: robocallData.frn || "",
                                      fcc_number: fccData.coresid || "",
                                      fcc_coresid: fccData.coresid || "",
                                      fcc_filing_url: robocallData.filing_url || "",
                                    });
                                    if (robocallData.contact_business_address) {
                                      this.parseAddressWithGoogle(
                                        robocallData.contact_business_address,
                                      );
                                    }
                                  } else {
                                    this.setState({
                                      errorFilerId: "error",
                                      fccLoading: false,
                                      fccSuccess: false,
                                    });
                                  }
                                }}
                              />
                            </div>
                          )}
                        </>
                      )}

                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="main_client_name"
                          name="main_client_name"
                          type="text"
                          label="Client"
                          value={this.state.main_client_name}
                          inputProps={{ maxLength: 64, readOnly: true }}
                          helperText="Assigned parent client"
                          variant="outlined"
                          disabled
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <MutextField
                          required={this.isFieldRequired('name')}
                          id="name"
                          name="name"
                          type="text"
                          label="Full Name"
                          inputProps={{ maxLength: 50 }}
                          value={this.state.name}
                          onChange={this.handleChange}
                          helperText="Enter the name"
                          variant="outlined"
                          fullWidth
                          error={this.state.errorName === "error"}
                        autoComplete="new-password"
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <MutextField
                          required={this.isFieldRequired('title')}
                          id="title"
                          name="title"
                          type="text"
                          inputProps={{ maxLength: 30 }}
                          label="Title"
                          value={this.state.title}
                          onChange={this.handleChange}
                          helperText="Enter the title"
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientTitle === "error"}
                        autoComplete="new-password"
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <MutextField
                          required={this.isFieldRequired('account_status')}
                          id="account_status"
                          name="account_status"
                          select
                          label="Account Status"
                          value={this.state.account_status}
                          onChange={this.handleChange}
                          SelectProps={{
                            native: true,
                          }}
                          helperText="Select the account status here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientStatus === "error"}
                        autoComplete="new-password"
                        >
                          <option key="" value=""></option>
                          <option key="5" value="active">
                            Active
                          </option>
                          <option key="10" value="inactive">
                            Inactive
                          </option>
                        </MutextField>
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          required={this.isFieldRequired('client_company')}
                          id="client_company"
                          name="client_company"
                          type="text"
                          inputProps={{ maxLength: 100 }}
                          InputProps={{
                            readOnly: this.state.isParentCompanyReadOnly,
                          }}
                          label="Company Name"
                          value={this.state.client_company}
                          onChange={this.handleChange}
                          helperText="Enter the company name"
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientCompany === "error"}
                        autoComplete="new-password"
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="client_email"
                          name="client_email"
                          type="email"
                          label="Email Address"
                          defaultValue={this.state.client_email}
                          onChange={this.handleChange}
                          helperText="Enter your email address here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientEmail === "error"}
                        autoComplete="new-password"
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <ReactPhoneInput
                          country={"us"}
                          value={this.state.client_phone}
                          onChange={(value) =>
                            this.handleChange({
                              target: { name: "client_phone", value }
                            })
                          }
                          inputProps={{
                            name: "client_phone",
                            id: "client_phone",
                            required: this.isFieldRequired("client_phone"),
                            maxLength: 20
                          }}
                          inputStyle={
                            this.state.errorClientPhone
                              ? { borderColor: "red", width: "100%", height:"56px" }
                              : { width: "100%", height:"56px" }
                          }
                          containerStyle={{ width: "100%" }}
                          specialLabel="Phone Number *"
                          placeholder="Enter the phone number here."
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <div
                          className="nk-block-between-md"
                          style={{
                            position: "absolute",
                            zIndex: 9999,
                            right: "13px",
                            top: "-15px",
                          }}
                        >
                          <div className="nk-block-head-content">
                            <label
                              htmlFor="googleLocation-autocomplete"
                              style={{
                                color: "black",
                                fontWeight: "500",
                                marginBottom: "8px",
                              }}
                            >
                              {" "}
                            </label>
                          </div>
                          {this.state.address_autocomplete === "Yes" && (
                            <div className="nk-block-head-content">
                              <ul className="nk-block-tools gx-3">
                                <li>
                                  <a
                                    onClick={this.handleToggle}
                                    className="text-primary fs-11"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {toggleButtonText}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                        {this.state.address_autocomplete === "Yes" ? (
                          useGooglePlaces ? (
                            <GooglePlacesAutocomplete
                              apiKey={
                                process.env
                                  .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                              }
                              apiOptions={{ loading: 'async' }}
                              selectProps={{
                                value: this.state.client_address
                                  ? {
                                      label: this.state.client_address,
                                      value: this.state.client_address,
                                    }
                                  : null,
                                onChange: this.handleAddressSelect,
                                placeholder: this.state.client_address
                                  ? null
                                  : "Enter your address..",
                                styles: {
                                  ...errorStyle,
                                  input: (provided) => ({
                                    ...provided,
                                    color: "black",
                                    height: "47px",
                                  }),
                                  option: (provided) => ({
                                    ...provided,
                                    color: "black",
                                  }),
                                  singleValue: (provided) => ({
                                    ...provided,
                                    color: "black",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9,
                                  }),
                                },
                              }}
                              className="googleLocation-autocomplete"
                            />
                          ) : (
                            <MutextField
                              required={this.isFieldRequired('client_address')}
                              id="client_address"
                              name="client_address"
                              type="text"
                              label="PO Box Address"
                              value={this.state.client_address}
                              inputProps={{ maxLength: 100 }}
                              onChange={this.handleChange}
                              helperText="Enter valid PO Box Address. i.e, PO Box Number, City, State Zip Code"
                              variant="outlined"
                              fullWidth
                              error={this.state.errorClientAddress === "error"}
                            autoComplete="new-password"
                            />
                          )
                        ) : (
                          // address_autocomplete === "No" → show PO Box only
                          <MutextField
                            required={this.isFieldRequired('client_address')}
                            id="client_address"
                            name="client_address"
                            type="text"
                            label="Address"
                            value={this.state.client_address}
                            onChange={this.handleChange}
                            helperText="Enter your address"
                            variant="outlined"
                            fullWidth
                            error={this.state.errorClientAddress === "error"}
                          autoComplete="new-password"
                          />
                        )}
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          id="client_address2"
                          name="client_address2"
                          type="text"
                          label="Address 2"
                          value={this.state.client_address2}
                          onChange={this.handleChange}
                          inputProps={{ maxLength: 100 }}
                          helperText="If needed, enter additional address details, such as apartment number, suite, or unit."
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>

                      <div
                        className="form-group col-md-2"
                        style={{ marginBottom: "0px" }}
                      >
                        <MutextField
                          required={this.isFieldRequired('client_city')}
                          id="client_city"
                          name="client_city"
                          type="text"
                          label="City"
                          value={this.state.client_city}
                          inputProps={{ maxLength: 32 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientCity === "error"}
                        autoComplete="new-password"
                        />
                      </div>
                      <div
                        className="form-group col-md-2"
                        style={{ marginBottom: "0px" }}
                      >
                        <MutextField
                          required={this.isFieldRequired('client_state')}
                          id="client_state"
                          name="client_state"
                          type="text"
                          label="State"
                          value={this.state.client_state}
                          inputProps={{ maxLength: 32 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientState === "error"}
                        autoComplete="new-password"
                        />
                      </div>
                      <div
                        className="form-group col-md-2"
                        style={{ marginBottom: "0px" }}
                      >
                        <MutextField
                          required={this.isFieldRequired('client_zip')}
                          id="client_zip"
                          name="client_zip"
                          type="text"
                          label="Zip"
                          value={this.state.client_zip}
                          inputProps={{ maxLength: 9 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorClientZip === "error"}
                        autoComplete="new-password"
                        />
                      </div>
                      <div
                        className="form-group col-md-6"
                        style={{ marginBottom: "0px" }}
                      >
                        <Autocomplete
                          id="client_country"
                          options={this.countryOptions}
                          getOptionLabel={(option) => option.label}
                          value={
                            this.state.client_country
                              ? this.countryOptions.find(
                                  (opt) => opt.label === this.state.client_country
                                ) || null
                              : null
                          }
                          onChange={(event, newValue) =>
                            this.handleChangeCountry(newValue)
                          }
                          renderInput={(params) => (
                            <MutextField
                              {...params}
                              label={this.isFieldRequired('client_country') ? 'Country *' : 'Country'}
                              variant="outlined"
                              placeholder="Select Country"
                              fullWidth
                              helperText="Select country"
                            autoComplete="new-password"
                            />
                          )}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              minHeight: "56px",
                            },
                          }}
                        />
                      </div>
                      <div
                        className="custom-control custom-control-lg custom-checkbox col-lg-12"
                        style={{
                          padding: 0,
                          marginLeft: "3rem",
                          marginBottom: "1rem",
                        }}
                      >
                        <div className="form-group">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck3"
                            checked={this.state.passwordRequired}
                            onChange={() => {
                              const isChecked = !this.state.passwordRequired;
                              this.setState({
                                passwordRequired: isChecked,
                              });
                              // console.log("Required Password:", isChecked);
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customCheck3"
                          >
                            Add Password
                          </label>
                        </div>
                      </div>

                      {this.state.passwordRequired && (
                        <>
                          <div
                            className="form-group col-md-6"
                            style={{ position: "relative" }}
                          >
                            <MutextField
                              required
                              id="client_password"
                              name="client_password"
                              type={
                                this.state.passwordShown ? "text" : "password"
                              }
                              label="Password"
                              defaultValue={this.state.client_password}
                              inputProps={{ maxLength: 50 }}
                              onChange={this.handleChange}
                              helperText=""
                              variant="outlined"
                              fullWidth
                              error={this.state.errorClientPassword === "error"}
                            autoComplete="new-password"
                            />
                            <a
                              style={{
                                left: "auto",
                                right: "10px",
                                top: "41px",
                                position: "absolute",
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={this.togglePassword}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="password"
                            >
                              {this.state.passwordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                            <small
                              className="form-text"
                              style={{
                                position: "absolute",
                                top: "69px",
                                left: "26px",
                                color: "#0000008a",
                                fontSize: "0.75rem",
                                fontWeight: "400",
                                fontFamily:
                                  '"Roboto", "Helvetica", "Arial", sans-serif',
                              }}
                            >
                              Password must be at least 8 characters, with
                              uppercase, lowercase, number & special character.
                            </small>
                            <div style={{ marginTop: "30px" }}>
                              <PasswordStrengthBar
                                password={this.state.client_password}
                              />
                            </div>
                          </div>
                          <div
                            className="form-group col-md-6"
                            style={{ position: "relative" }}
                          >
                            <MutextField
                              required
                              id="c_password"
                              name="c_password"
                              type={
                                this.state.confirmPasswordShown
                                  ? "text"
                                  : "password"
                              }
                              label="Confirm Password"
                              defaultValue={this.state.c_password}
                              inputProps={{ maxLength: 50 }}
                              onChange={this.handleChange}
                              helperText=""
                              variant="outlined"
                              fullWidth
                              error={this.state.errorCPassword === "error"}
                            autoComplete="new-password"
                            />
                            <a
                              style={{
                                left: "auto",
                                right: "10px",
                                top: "41px",
                                position: "absolute",
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={this.toggleConfirmPassword}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="password"
                            >
                              {this.state.confirmPasswordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                            <small
                              className="form-text"
                              style={{
                                position: "absolute",
                                top: "69px",
                                left: "26px",
                                color: "#0000008a",
                                fontSize: "0.75rem",
                                fontWeight: "400",
                                fontFamily:
                                  '"Roboto", "Helvetica", "Arial", sans-serif',
                              }}
                            >
                              Confirm Password must be at least 8 characters,
                              with uppercase, lowercase, number & special
                              character. Confirm Password must match the
                              Password.
                            </small>
                          </div>
                        </>
                      )}
                      <div
                        className="custom-control custom-control-lg custom-checkbox col-lg-12"
                        style={{ padding: 0, marginLeft: "3rem" }}
                      >
                        <div className="form-group">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck2"
                            checked={this.state.notifyCheckBox}
                            onChange={() => {
                              const isChecked = !this.state.notifyCheckBox;
                              this.setState({ notifyCheckBox: isChecked });
                              // console.log(
                              //   "Notify Checkbox Checked:",
                              //   isChecked
                              // );
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customCheck2"
                          >
                            Notify Sub User
                          </label>
                        </div>
                      </div>
                      <div
                        className="col-lg-12 no-padding-preview"
                        style={{
                          padding: 0,
                          cursor: "pointer",
                          color: "#0066cc",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.preViewDefault();
                        }}
                      >
                        <span>Preview Notification Email </span>
                      </div>
                      <div style={{ clear: "both" }}></div>
                      <hr />
                      <div className="form-group text-right col-md-12">
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled={this.state.disabled}
                          onClick={this.formClientUpdate}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>

                  <br />
                  <br />
                </div>
              </div>
            </div>
            {/* PREVIEW DEFAULT MODAL  */}
            <div
              className="modal fade"
              tabIndex="-1"
              id="modalPreviewDefaultModal"
              style={{ zIndex: "9999" }}
            >
              <div
                className="modal-dialog modal-xl modal-dialog-top"
                role="document"
              >
                <div className="modal-content">
                  <div
                    className="modal-header"
                    style={{ borderBottom: "1px solid #e5e9f2" }}
                  >
                    <h5
                      className="modal-title"
                      style={{
                        fontFamily: "'DM Sans', sans-serif",
                        fontWeight: "700",
                        fontSize: "1.25rem",
                        color: "#364a63",
                      }}
                    >
                      Preview Notification Email
                    </h5>
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => this.closePreviewModal()}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                  </div>
                  <div className="modal-body" style={{ padding: "1.5rem" }}>
                    <div className="nk-block">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          <div
                            className="email-preview"
                            style={{
                              maxHeight: "60vh",
                              overflow: "auto",
                              padding: "1rem",
                              backgroundColor: "#f5f6fa",
                              borderRadius: "4px",
                            }}
                          >
                            {this.state.isEditorReady ? (
                              <div>
                                <style>
                                  {`
                                  .email-preview-content button,
                                  .email-preview-content a {
                                    pointer-events: none !important;
                                    cursor: not-allowed !important;
                                    text-decoration: none;
                                  }
                                `}
                                </style>
                                <div
                                  className="email-preview-content"
                                  style={{
                                    fontFamily: "'Roboto', sans-serif",
                                    fontSize: "14px",
                                    lineHeight: "1.65",
                                    pointerEvents: "none",
                                    userSelect: "none",
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.email_template,
                                  }}
                                />
                              </div>
                            ) : (
                              tableLoader()
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="modal-footer"
                    style={{
                      borderTop: "1px solid #e5e9f2",
                      padding: "1rem 1.5rem",
                    }}
                  >
                    <button
                      onClick={() => this.closePreviewModal()}
                      className="btn btn-primary"
                      style={{
                        fontFamily: "'DM Sans', sans-serif",
                        fontWeight: "500",
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* PREVIEW DEFAULT MODAL  */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Addclient);
